// extracted by mini-css-extract-plugin
export default {"select":"CustomSelect_select__S16vV","label":"CustomSelect_label__QwJvi","customSelect":"CustomSelect_customSelect__3bsrf","error":"CustomSelect_error__P18GW"};